import ParserModule from "../ParserModule";
export default class IndexComplementorModule extends ParserModule {
    appendIndices(args) {
        if (args.primitive.indices === void 0) {
            const topology = args.primitive.mode || WebGLRenderingContext.TRIANGLES;
            const accessor = args.tf.accessors[args.primitive.attributes["POSITION"]];
            if (accessor.count === void 0) {
                throw new Error("POSITION buffer should have count parameter. Construction of index buffer was failed.");
            }
            if (topology !== WebGLRenderingContext.TRIANGLES) {
                throw new Error("Complementing index buffer is only supported for TRIANGLES topology currently.");
            }
            const indices = new Array(accessor.count);
            for (let i = 0; i < accessor.count; i++) {
                indices[i] = i;
            }
            args.geometry.addIndex("default", indices);
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Parser/Modules/IndexComplementorModule.ts